export const ADD_TRANSFER = "ADD_TRANSFER"
export const REMOVE_TRANSFER = "REMOVE_TRANSFER"
export const UPDATE_TRANSFER = "UPDATE_TRANSFER"
export const ASPERA_PROGRESS = "ASPERA_PROGRESS"
export const TRANSFER_PROGRESS = "TRANSFER_PROGRESS"
export const UPDATE_CHILD_TRANSFER = "UPDATE_CHILD_TRANSFER"